/* experiment AO-238 */
class ShippingProtection extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.querySelector(
      ".cart__checkout-button--shipping-protection",
    )?.addEventListener("click", (evt) => {
      evt.preventDefault();
      evt.stopPropagation();
      this.submitCartDrawer();
    });
  }

  async submitCartDrawer() {
    const varId = parseInt(this.getAttribute("shipping-protection"));
    const shippingProtection = this;
    let formData = {
      items: [
        {
          id: varId,
          quantity: 1,
          properties: {
            Disclaimer:
              "",
          },
        },
      ],
    };
    let hasError = false;
    window._igNavidiumConfig = {
      isOn: true, // widget on off
    };

    await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        attributes: {
          _igNavidiumConfig: JSON.stringify(window._igNavidiumConfig),
        },
      }),
    });
    await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        hasError = true;
        console.error("Error:", error);
      })
      .finally(() => {
        if (hasError) {
          console.log("Fetch failed, skipping submit");
          return; // 🚫 stop here if error
        }
        shippingProtection
          .closest("cart-items-component")
          .querySelector(" #cart-form")
          .requestSubmit(
            shippingProtection.querySelector(
              ".cart__checkout-button--shipping-protection",
            ),
          );
      });
  }
}

if (!customElements.get("shipping-protection")) {
  customElements.define("shipping-protection", ShippingProtection);
}
/* end experiment AO-238 */
